import React from 'react';
import EmojiMobile from '../../assets/emoji_mobile.webp';
import EmojiPalette from '../../assets/emoji_palette.webp';
import EmojiGift from '../../assets/emoji_wrapped_gift.webp';
import EmojiBomb from '../../assets/emoji_bomb.webp';

import MobileEmojiMobile from '../../assets/mobile/emoji_mobile.webp';
import MobileEmojiPalette from '../../assets/mobile/emoji_palette.webp';
import MobileEmojiGift from '../../assets/mobile/emoji_wrapped_gift.webp';
import MobileEmojiBomb from '../../assets/mobile/emoji_bomb.webp';

import VideoConfigurations from '../../assets/video_configurations.mp4';
import VideoShowcase from '../../assets/video_showcase.mp4';
import VideoIntegrations from '../../assets/video_integrations.mp4';

import PosterConfigurations from '../../assets/poster_configurations.webp';
import PosterShowcase from '../../assets/poster_showcase.webp';
import PosterIntegrations from '../../assets/poster_integrations.webp';

import ImageAr from '../../assets/feature_ar.webp';
import MobileImageAr from '../../assets/mobile/feature_ar.webp';

const FEATURES_CONTENT = [
  {
    icon: [EmojiMobile, MobileEmojiMobile],
    heading: 'Augmented Reality',
    text: (
      <>
        Close to life AR view of the product accessible natively in the browser on most smartphones
      </>
    ),
    image: [ImageAr, MobileImageAr],
    imgClass: 'mobile',
  },
  {
    icon: [EmojiPalette, MobileEmojiPalette],
    heading: 'Product Configurations',
    text: (
      <>Does your product have multiple colours and materials? No worries. We got you covered!</>
    ),
    video: VideoConfigurations,
    poster: PosterConfigurations,
  },
  {
    icon: [EmojiGift, MobileEmojiGift],
    heading: 'Usage Showcase',
    text: <>Zoom view and animations let you convey product features better</>,
    video: VideoShowcase,
    poster: PosterShowcase,
  },
  {
    icon: [EmojiBomb, MobileEmojiBomb],
    heading: 'Powerful Integrations',
    text: (
      <>
        Our viewer works seamlessly with Salesforce, Magento, Shopify, and a lot more e-commerce
        solutions
      </>
    ),
    video: VideoIntegrations,
    poster: PosterIntegrations,
  },
];

const LandingFeatures = () => (
  <div className="landing-width-limit padding-lr-30" id="landing-features">
    {FEATURES_CONTENT.map(({ icon, heading, text, video, image, imgClass, poster }) => (
      <div className="landing-features-item" key={heading}>
        {video ? (
          <video
            muted
            loop
            autoPlay
            playsInline
            preload="metadata"
            className="landing-features-item-img lazy"
            poster={poster}>
            <source data-src={video} type="video/mp4" />
          </video>
        ) : (
          <img
            className="landing-features-item-img"
            src={image[0]}
            alt=""
            loading="lazy"
            srcSet={`${image[0]} 1400w, ${image[1]} 1000w`}
            width={1400}
            height={1000}
          />
        )}

        <div className="landing-features-item-content">
          <img
            className={`landing-features-item-icon ${imgClass || ''}`}
            src={icon[0]}
            srcSet={`${icon[0]} 158w, ${icon[1]} 79w`}
            width={158}
            height={158}
            alt=""
            loading="lazy"
          />
          <div>
            <h3 className="landing-features-item-heading">{heading}</h3>
            <p className="landing-features-item-text">{text}</p>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default LandingFeatures;
